import { useContext } from 'react';
import PortfolioItemContext from '../../PortfolioItemContext';
import { fileErrorStates } from '@/components/FileAttachments/UploadedImage';
import useThumbnailFileStatusRefreshing from './useThumbnailFileStatusRefreshing';
import ThumbnailBannerImage from './ThumbnailBannerImage';
import { finalFileStates } from '@/lib/files/useFileStatusRefreshing';
import BannerWrapper from './BannerWrapper';
import ThumbnailControls from './ThumbnailControls';
import ThumbnailProcessingState from './ThumbnailProcessingState';
import { FileStatus } from '@/lib/types';
import ThumbnailErrorState from './ThumbnailErrorState';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';

const ThumbnailBanner = () => {
  useThumbnailFileStatusRefreshing();

  const { portfolioItem } = useContext(PortfolioItemContext);
  const thumbnail = portfolioItem.thumbnail!;

  const showErrorState = fileErrorStates.includes(thumbnail.file.status);

  if (showErrorState) {
    return (
      <ThumbnailErrorState
        variant={
          thumbnail.file.status === FileStatus.ANTIVIRUS_QUARANTINED
            ? 'malware'
            : 'inappropriate_content'
        }
      />
    );
  }

  const isProcessing = !finalFileStates.includes(thumbnail.file.status);

  return (
    <BannerWrapper isShowingImage={!isProcessing}>
      {isProcessing ? (
        <ThumbnailProcessingState />
      ) : (
        <>
          <ThumbnailBannerImage />
          <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
            <ThumbnailControls />
          </RestrictedToPortfolioMode>
        </>
      )}
    </BannerWrapper>
  );
};

export default ThumbnailBanner;
